import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useWorkerQualifications } from "@src/appV2/Worker/useWorkerQualifications";

import { useIsSurfaceShiftsEnabled } from "../ShiftDiscovery/useIsSurfaceShiftsEnabled";

const ALLOWED_LICENSE_STATUSES = new Set(["ACTIVE", "PENDING", "EXPIRED", "EXPIRING"]);

/**
 * This is a very hacky hook that is used to get the licenses that are allowed for documents.
 * If surface shifts is not enabled, it filters out the licenses that are not active, pending, or expired from worker's licenses attribute.
 * This should be replaced once surface shifts is enabled, with just normal worker qualifications.
 */
export function useGetWorkerLicensesAllowedForDocuments() {
  const isSurfaceShiftsEnabled = useIsSurfaceShiftsEnabled();
  const { licenses } = useDefinedWorker();

  const { data: workerQualifications, isSuccess: workerQualificationsAreLoaded } =
    useWorkerQualifications();

  if (isSurfaceShiftsEnabled) {
    return {
      licenses: workerQualificationsAreLoaded
        ? workerQualifications?.map((qualification) => qualification.attributes.name)
        : [],
      isLoaded: workerQualificationsAreLoaded,
      // in this case, we don't care about the status of the licenses being pending, as we support showing documents for qualifications that are pending with surface shifts enabled
      areAllLicensesPending: false,
    };
  }

  const allowedLicenses = licenses.filter(({ attributes }) =>
    ALLOWED_LICENSE_STATUSES.has(attributes.status)
  );

  // Allow for any rejected licenses to be shown for documents if there are no existing allowed licenses
  const applicableLicenses =
    allowedLicenses.length === 0
      ? licenses.filter(({ attributes }) => attributes.status === "REJECTED")
      : allowedLicenses;

  return {
    licenses: applicableLicenses.map((license) => license.attributes.qualification),
    isLoaded: true,
    areAllLicensesPending: applicableLicenses.every(
      ({ attributes }) => attributes.status === "PENDING"
    ),
  };
}
